import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import NavigatorMain from './NavigatorMain';
import {choseTargetIndex} from '../action/productAction';

class TargetFundsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      
    };
  }
  componentWillMount() {
    document.title = "转入组合"
  }
  changeIndex(item,i){
    this.props.dispatch(choseTargetIndex(i))
    hashHistory.goBack()
  }
  render(){
    let {
      dataSouse
    }=this.props.location.state;//nav 传入
    let icon=[require('../img/circleHookG.png'),require('../img/circleHookO.png')];
    let {targetIndex}=this.props;
    return(
      <div className="container" >
        <NavigatorMain>
          <div className="header">
            <div onClick={hashHistory.goBack}><span className="headerLeftBtn"></span></div>
            <div>转入组合</div>
            <div></div>
          </div>
        </NavigatorMain>
        <div className='content'>
          {
            dataSouse.map( (item,i)=>{
              return(
                <div key={i} className='currencyList' onClick={()=>this.changeIndex(item,i)}>
                  <div>
                    <div style={{color:'#3a3f47',fontSize:16}}>{item.superFundName}</div>
                    <div style={{color:'#5c6470',fontSize:14}}>{item.superFundCode}</div>
                  </div>
                  <div className='bankListRightOK'>
                    <img src={targetIndex===i?icon[1]:icon[0]} className='img'/>
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    targetIndex:state.targetIndex,
  }
}
export default connect(mapStateToProps)(TargetFundsList);


// WEBPACK FOOTER //
// ./src/components/TargetFundsList.js